<template>
    <div>
        <syn-dialog ref="synDialog" :syn-time="synTime" @syn="getSynStatus" />
    </div>
</template>

<script>
import SynDialog from './SynDialog';
import dayjs from 'dayjs';
let time = null;
export default {
    components: {
        SynDialog,
    },
    data() {
        return {
            synTime: '',
            percentage: 0,
            synStatus: 0,
        };
    },
    mounted() {
        this.synTime = JSON.parse(localStorage.getItem('synTime'));
        this.getSynStatus();
        this.$bus.$on('openSyn', this.handleSyn);
    },
    methods: {
        handleSyn() {
            if (this.synStatus != 0) {
                return;
            }
            this.$refs.synDialog.open();
        },
        loop() {
            if (time) {
                clearTimeout(time);
            }
            time = setTimeout(() => {
                this.$ajax
                    .post('api/tiktok/Product/GetSyncProcessInfo', {
                        noMsg: 'noMsg',
                    })
                    .then((data) => {
                        if (data.code === 999) {
                            this.synStatus = 0;
                            return;
                        }

                        this.showData(data.result);
                    })
                    .catch(() => {
                        clearTimeout(time);
                        setTimeout(() => {
                            this.synStatus = 0;
                        }, 3000);
                    });
            }, 3000);
        },
        // 查看任务进度
        getSynStatus() {
            this.loop(); // 接口查询进度
        },
        showData(data) {
            //taskState 0-等待中，1-执行中，2-已完成，3-已取消，4-系统取消
            if (data.TaskState === 0 || data.TaskState === 1 || data.taskState === 0 || data.taskState === 1) {
                this.synStatus = 1;
                this.percentage = data.Progress ? data.Progress : data.progress;
                this.loop();
            } else {
                this.synTime = dayjs(data.CreateTime).format('YYYY-MM-DD HH:mm:ss');
                localStorage.setItem('synTime', JSON.stringify(this.synTime));
                this.$bus.$emit('getSynTime', this.synTime);
                if (
                    data.TaskState === 2 ||
                    data.TaskState === 3 ||
                    data.taskState === 2 ||
                    data.taskState === 3 ||
                    data.taskState === 4
                ) {
                    clearTimeout(time);
                    this.synStatus = 2;
                    this.percentage = data.Progress ? data.Progress : data.progress;
                    setTimeout(() => {
                        this.synStatus = 0;
                    }, 3000);
                }
            }
        },
    },
    watch: {
        synStatus(val) {
            this.$emit('synChange', val);
        },
    },
};
</script>
<style lang="scss" scoped>
@keyframes rotate {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
}

.syning {
    animation: rotate 2s infinite;
}
.syn-btn {
    cursor: pointer;
    width: 96px;
    height: 32px;
    font-size: 12px;
    background: linear-gradient(93deg, #f6fffb 0%, #d0edf1 100%);
    border-radius: 16px 16px 16px 16px;
    line-height: 1;
    // border: 1px solid #ff8e3b;
    color: #42558a;
    margin-right: 20px;

    i {
        font-size: 16px;
        margin-right: 7px;
    }
}
</style>
